<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="revision_scientifique" v-model="sasAccreditation.revisionScientifique" :live="liveSasAccreditation(24617)" descending />
    <CaseACocherLive code="engagement_criteres" v-model="sasAccreditation.engagementCriteresRespectes" :live="liveSasAccreditation(24633)" />
    <CaseACocherLive
      code="consentement_complements_audit"
      v-model="sasAccreditation.consentementComplementsEtAudit"
      :live="liveSasAccreditation(24635)"
    />
    <CaseACocherLive code="engagements_generaux" v-model="sasAccreditation.engagementsGeneraux" :live="liveSasAccreditation(24634)" />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasAccreditation() {
      return this.sas.sasAccreditation
    }
  },
  methods: {
    liveSasAccreditation(cle) {
      return { endpoint: "sas-accreditations", cle: cle, fileId: this.sasAccreditation.id }
    }
  }
}
</script>

<style></style>
